import { IDeviceNavigator } from "../../domain/interfaces/IDeviceNavigator";

const ApproveDeviceUseCase = async (deviceService: IDeviceNavigator, localId: string, solicitationId: string): Promise<void> => {
    await deviceService.approve(localId, solicitationId);
};

export default ApproveDeviceUseCase